import Toast from "@/components/Toast"
import { collect } from "@/utils/sdk"
import { i18n } from "@/i18n"

export const onImageSaved = (target: "recall" | "game") => {
    collect("social_media_share", {
        channel: "save_as_image",
        target,
    })
}

export const downloadShareImage = (src: string, target: "recall" | "game") => {
    if (!src) {
        Toast.message("download error")
        return
    }

    const downloadTitle = i18n.getRecall("share.share_title")

    const aTag = document.createElement("a")
    if (!aTag || !src) {
        Toast.message("download fail")
        return
    }
    aTag.download = `${downloadTitle}.png`
    aTag.href = src
    aTag.click()
    onImageSaved(target)
}
